// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-sidebar_sidebar__XIYB6 {
    min-height: 100%;
    width: 92px;
    overflow: auto;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    z-index: 3;
}

.main-sidebar_sidebar-pro__-cqSw {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background-color: var(--color-sidebar-pro);
    flex: 5 2 auto;
}

.main-sidebar_sidebar-regular__pIQHq {
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: var(--color-sidebar);
    flex: 7 2 auto;
}

.main-sidebar_sidebar-close__URspg {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--color-sidebar-pro);
    flex: 1 2 auto;
}

.main-sidebar_sidebar-user-container__FpWAs {
    display: block;
    padding-top: 90px;
}

.main-sidebar_siderbar-item__SbbRH {
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.main-sidebar_close-button__2bBwf {
    background: none;
    border: none;
}

@media screen and (max-width: 1000px) {
    .main-sidebar_sidebar-pro__-cqSw {
        justify-content: center;
        gap: 20px;
        flex-direction: column;
        align-items: left;
        justify-content: left;
        padding: 20px 15px;
    }
    
    .main-sidebar_sidebar-regular__pIQHq {
        padding: 20px 15px;
        justify-content: center;
        gap: 20px;
        flex-direction: column;
        align-items: left;
        justify-content: left;
    }

    .main-sidebar_sidebar-close__URspg {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: var(--color-sidebar-pro);
        flex: 1 2 auto;
    }
    
    .main-sidebar_sidebar-user-container__FpWAs {
        width: 100%;
        padding-top: 80px;
        display: flex;
        flex-direction: row;
        color: var(--color-sidebar-typography-disabled);
        gap: 10px;
        align-items: center;
        justify-content: left;
    }

    .main-sidebar_sidebar-item__sNKHW {
        flex-direction: row;
        align-items: left;
        justify-content: left;
        height: 40px;
        width: auto;
    }

    .main-sidebar_sidebar__XIYB6 {
        min-height: 100vh;
        width: 100%;
        overflow: auto;
        position: fixed;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: flex-start;
        z-index: 3;
    }

    .main-sidebar_mobile-header__3cGBy {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/main-sidebar/main-sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;QACvB,SAAS;QACT,sBAAsB;QACtB,iBAAiB;QACjB,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,SAAS;QACT,sBAAsB;QACtB,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,0CAA0C;QAC1C,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,+CAA+C;QAC/C,SAAS;QACT,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,cAAc;QACd,eAAe;QACf,OAAO;QACP,MAAM;QACN,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,8BAA8B;IAClC;AACJ","sourcesContent":[".sidebar {\n    min-height: 100%;\n    width: 92px;\n    overflow: auto;\n    position: fixed;\n    left: 0;\n    top: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    z-index: 3;\n}\n\n.sidebar-pro {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-evenly;\n    background-color: var(--color-sidebar-pro);\n    flex: 5 2 auto;\n}\n\n.sidebar-regular {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--color-sidebar);\n    flex: 7 2 auto;\n}\n\n.sidebar-close {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--color-sidebar-pro);\n    flex: 1 2 auto;\n}\n\n.sidebar-user-container {\n    display: block;\n    padding-top: 90px;\n}\n\n.siderbar-item {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.close-button {\n    background: none;\n    border: none;\n}\n\n@media screen and (max-width: 1000px) {\n    .sidebar-pro {\n        justify-content: center;\n        gap: 20px;\n        flex-direction: column;\n        align-items: left;\n        justify-content: left;\n        padding: 20px 15px;\n    }\n    \n    .sidebar-regular {\n        padding: 20px 15px;\n        justify-content: center;\n        gap: 20px;\n        flex-direction: column;\n        align-items: left;\n        justify-content: left;\n    }\n\n    .sidebar-close {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        background-color: var(--color-sidebar-pro);\n        flex: 1 2 auto;\n    }\n    \n    .sidebar-user-container {\n        width: 100%;\n        padding-top: 80px;\n        display: flex;\n        flex-direction: row;\n        color: var(--color-sidebar-typography-disabled);\n        gap: 10px;\n        align-items: center;\n        justify-content: left;\n    }\n\n    .sidebar-item {\n        flex-direction: row;\n        align-items: left;\n        justify-content: left;\n        height: 40px;\n        width: auto;\n    }\n\n    .sidebar {\n        min-height: 100vh;\n        width: 100%;\n        overflow: auto;\n        position: fixed;\n        left: 0;\n        top: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: left;\n        justify-content: flex-start;\n        z-index: 3;\n    }\n\n    .mobile-header {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        justify-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `main-sidebar_sidebar__XIYB6`,
	"sidebar-pro": `main-sidebar_sidebar-pro__-cqSw`,
	"sidebar-regular": `main-sidebar_sidebar-regular__pIQHq`,
	"sidebar-close": `main-sidebar_sidebar-close__URspg`,
	"sidebar-user-container": `main-sidebar_sidebar-user-container__FpWAs`,
	"siderbar-item": `main-sidebar_siderbar-item__SbbRH`,
	"close-button": `main-sidebar_close-button__2bBwf`,
	"sidebar-item": `main-sidebar_sidebar-item__sNKHW`,
	"mobile-header": `main-sidebar_mobile-header__3cGBy`
};
export default ___CSS_LOADER_EXPORT___;
